export default "__VITE_ASSET__2bb10a62__$_?nuxt_component=async__"